import templateUrl from "./checkbox-list.html"
import "./checkbox-list.less"
import { CheckboxListController } from "./CheckboxList"

export const CheckboxListComponent = {
    bindings: {
        items: "<itemList",
        selected: "<selectedItemList",
        readOnly: "<?readonly",
        valueField: "@",
        collectionName: "@",
        class: "@",
        checkboxListChange: "&"
    },
    controller: CheckboxListController,
    controllerAs: "vm",
    templateUrl
}
